"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Placements_1 = __importDefault(require("../entity/FacetParts/Placements"));
const defaultValue = [
    { value: 'facebook', count: 20 },
    { value: 'google', count: 5 },
    { value: 'instagram', count: 1 },
    { value: 'line', count: 2 },
    { value: 'twitter', count: 2 },
    { value: 'yahoo', count: 2 },
    { value: 'youtube', count: 2 },
];
exports.generatePlacementEntity = (jsons = defaultValue) => Placements_1.default.fromJSON({
    buckets: jsons,
});
